<div class="modal-content">
  <div class="modal-header" *ngIf="option.title">{{ option.title }}</div>
  <div class="modal-body">
    <input class="form-control" [placeholder]="option.placeholder" name="text"
      *ngIf="!option.type" [(ngModel)]="selectedValue" autofocus>

    <app-field-input-date *ngIf="option.type === 'date'"
      [ngModel]="selectedValue" format="DD/MM/YYYY"
      (onChangeValue)="setDate($event)" autofocus>
    </app-field-input-date>

    <app-field-input-date *ngIf="option.type === 'datetime'"
      [ngModel]="selectedValue" format="DD/MM/YYYY HH:mm"
      (onChangeValue)="setDate($event)" autofocus>
    </app-field-input-date>

    <div class="multiple-dates" *ngIf="option.type === 'dates'">
      <p-calendar [(ngModel)]="selectedValue"
        selectionMode="multiple" [readonlyInput]="true" inputId="multiple"
        [inline]="true" [locale]="calendarPtBr">
      </p-calendar>
    </div>

    <div *ngIf="option.type === 'texts'">
      <select class="form-control" [(ngModel)]="selectedValue">
        <option *ngFor="let item of option.value" [ngValue]="item">{{ item }}</option>
      </select>
    </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="!valid()" (click)="done($event)">OK</button>
    <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">Cancelar</button>
  </div>
</div>
